import { createAction } from "@reduxjs/toolkit";

import { sliceName } from "./initialState";

export const setUsePromotionAction = createAction(`${sliceName}/setUsePromotion`, (usePromotion) => {
	return {
		payload: { usePromotion }
	};
});

export const setShowPromotionRulesAction = createAction(`${sliceName}/setShowPromotionRules`, (showRules) => {
	return {
		payload: { showRules }
	};
});

export const toggleShowPromotionRulesAction = createAction(`${sliceName}/toggleShowPromotionRules`);

export const setPromotionBets = createAction(`${sliceName}/setPromotionBets`, (promotionBets, isMulti, totalFactor, possibleWin) => {
	return {
		payload: { promotionBets, isMulti, totalFactor, possibleWin }
	};
});

export const pushPromotionBets = createAction(`${sliceName}/pushPromotionBets`, (promotionBets) => {
	return {
		payload: { promotionBets }
	};
});